/**
 * Get the current language.
 *
 * @param pageParams The page parameters from the App router.
 * @param pageParams.lang The language parameter.
 * @returns The current language.
 */
export function getLanguage(pageParams) {
    return pageParams.lang === "fr" ? "fr" : "en";
}
/**
 * Check if the current language is French.
 *
 * @param pageParams The page parameters from the App router.
 * @param pageParams.lang The language parameter.
 * @returns Whether the current language is French.
 */
export function isFrench(pageParams) {
    return getLanguage(pageParams) === "fr";
}
/**
 * Get a localized field from an object.
 *
 * @example
 * 	const object = {
 * 		label_en: "English label",
 * 		label_fr: "French label",
 * 	};
 * 	getLocalizedField(object, "label_", "en"); // "English label"
 * 	getLocalizedField(object, "label_", "fr"); // "French label"
 *
 * @template T The type stored in the field.
 * @template S The type of the object.
 * @param object The object.
 * @param fieldPrefix The field prefix. (e.g. "label_" for "label_en" and
 *   "label_fr")
 * @param lang The language to get the field for.
 * @returns The localized field value.
 * @throws Error If the field is not found in the object.
 */
export function getLocalizedField(object, fieldPrefix, lang) {
    const key = `${fieldPrefix}${lang}`;
    if (key in object) {
        return object[key];
    }
    throw new Error(`Field ${key} not found in object`);
}
//# sourceMappingURL=helpers.js.map